import departments from '../../node/static/seo/departments-250-fr-FR.json'
import { isFranceCountryCode } from '../../routes/address/Countries'

export const getDepartments = () => {
  return departments
}

export default class DepartmentService {
  static findDepartmentByCode(departmentCode) {
    return getDepartments().find(department => department.code === departmentCode.toString())
  }

  static findBorderingDepartments(departmentCode, countryCode) {
    if (isFranceCountryCode(countryCode)) {
      const department = this.findDepartmentByCode(departmentCode)
      const borderingDepartments = []
      department?.nextTo.forEach(borderDepartmentCode => {
        const borderDepartment = this.findDepartmentByCode(borderDepartmentCode)
        if (borderDepartment) borderingDepartments.push(borderDepartment)
      })

      return borderingDepartments
    }
  }

  static findDepartmentsFromRegionCode(regionCode, countryCode) {
    if (isFranceCountryCode(countryCode))
      return getDepartments().filter(department => department.regionId === regionCode)
  }
}
